import { FilePicker } from "@4uhub/lib4uhub";
import { Avatar, Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const translationPath =
  "chatBot.page.register.ticketServiceWhats.whatsappProfilePath.";

export const ProfilePicture = memo(
  ({ profilePictureUrl }: { profilePictureUrl: string | null }) => {
    const { t } = useTranslation();
    return (
      <Grid item xs={12} sm={12}>
        <Typography>{t(translationPath + "profile_picture")}</Typography>
        {profilePictureUrl && (
          <Avatar
            sx={{ width: 100, height: 100, mb: 2, p: 4 }}
            src={profilePictureUrl}
          />
        )}
        <Grid item xs={12} sm={12}>
          <FilePicker
            name="file"
            label={t(translationPath + "select_file") || "Selecione um arquivo"}
            accept="jpg,png,jpeg,pneg"
            maxSize={5}
          />
        </Grid>
      </Grid>
    );
  }
);
